module.exports = __webpack_public_path__ + "static/media/swing.01372bc4.svg";